import { PhoneShell } from './PhoneShell'
import { Toast } from './Toast'
import type { Vals } from '../demo/vals'

import { AppChrome } from './screens/member/AppChrome'
import { AlertFeed } from './screens/member/AlertFeed'
import { ConsentRequest } from './screens/member/ConsentRequest'
import { Home } from './screens/member/Home'
import { JoinInvite } from './screens/member/JoinInvite'
import { MailApp } from './screens/member/MailApp'
import { MessagesApp } from './screens/member/MessagesApp'
import { NordAccountSignup } from './screens/member/NordAccountSignup'
import { QrScanner } from './screens/QrScanner'
import { ShareInvite } from './screens/ShareInvite'
import { LockScreen } from './screens/member/LockScreen'
import { Monitor } from './screens/member/Monitor'
import { Profile } from './screens/member/Profile'
import { StopSharing } from './screens/member/StopSharing'
import { ThreatBlocked } from './screens/member/ThreatBlocked'
import { ThreatProtection } from './screens/member/ThreatProtection'

/**
 * Vito's handset — the member side. Everything the manager can see is opt-in,
 * and every opt-in decision is made here.
 */
export function MemberPhone({ v, scale }: { v: Vals; scale: number }) {
  return (
    <PhoneShell label="Member phone" scale={scale} finish="aluminium">
      {v.kAppChrome ? <AppChrome v={v} /> : null}
      {v.toastK ? <Toast text={v.toastK} /> : null}

      {v.kLock ? <LockScreen v={v} /> : null}
      {v.kMail ? <MailApp v={v} /> : null}
      {v.kMessages ? <MessagesApp v={v} /> : null}
      {v.kSignup ? <NordAccountSignup v={v} /> : null}
      {v.kJoin ? <JoinInvite v={v} /> : null}
      {v.kHome ? <Home v={v} /> : null}
      {v.kProtect ? <ThreatProtection v={v} /> : null}
      {v.kMonitor ? <Monitor v={v} /> : null}
      {v.kProfile ? <Profile v={v} /> : null}
      {v.kAlerts ? <AlertFeed v={v} /> : null}
      {v.kShareInvite ? (
        <ShareInvite v={v} onBack={v.memberClosePairing} onSend={v.sendPairRequest} />
      ) : null}
      {v.kScanner ? (
        <QrScanner onBack={v.memberClosePairing} onScan={() => v.completePairing('k')} />
      ) : null}

      {v.kDeviceRequest ? <ConsentRequest v={v} /> : null}
      {v.kDeviceOff ? <StopSharing v={v} /> : null}
      {v.kBlocked ? <ThreatBlocked v={v} /> : null}
    </PhoneShell>
  )
}
